var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ancho"},[_c('div',{staticClass:"snippet",attrs:{"data-title":".dot-pulse"}},[_c('div',{staticClass:"stage"},[_c('div',{staticClass:"dot-pulse"})])])])
}]

export { render, staticRenderFns }